<template>
    <c-dialog ref="dialog" width="450" height="350" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="商户">
                <c-select name="saas_id" v-model="saasId" async @search="searchSaasInfo" :value-data="selectedSaasInfo"></c-select>
            </c-form-item>
            <c-form-item label="电子货架" tip="多个电子货架号间使用逗号分隔">
                <c-input type="textarea" name="electronic_shelf_number" textarea maxlength="150"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    name:'saasShelfEdit',
    data() {
        return {
            saasId:0,
            selectedSaasInfo:[] //已选中的商户
        }
    },
    computed: {
    },

    methods: {
        /*******搜索SAAS商家*****************/
        searchSaasInfo(keyword, resolve){
            this.request({
                url:'/sys_saas/options',
                data: {
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
        /*********打开编辑框，初始化**********/
        open(data) {
            this.$refs.form.clear();
            if (data) {
                this.$refs.form.set(data);
                this.selectedSaasInfo = [{
                    value: data.saas_id,
                    name:data.saas_id + ' | ' + data.saas_name
                }];
            }
            //填充form表单
            this.$refs.dialog.open({
                title: data?'编辑商户电子货架':'新增商户电子货架'
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/sys_saas/edit/shelf_number',
                rule: {
                    saas_id: '请选择商户信息',
                    electronic_shelf_number: '请输入电子货架编码'
                },
                dataFormatter: data => {
                    data.saas_id = this.saasId;
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>